// 可查询的Odoo模型配置
export const availableModels = [
  { value: "purchase.order", label: "purchase.order" },
  { value: "purchase.order.line", label: "purchase.order.line" },
  { value: "product.product", label: "product.product" },
  { value: "product.supplierinfo", label: "product.supplierinfo" },
  { value: "res.partner", label: "res.partner" },
  { value: "sale.order", label: "sale.order" },
  { value: "account.incoterms", label: "account.incoterms" },
  { value: "stock.picking", label: "stock.picking" },
];

// 字段类型定义
export const fieldTypes = {
  ID: "id",
  STRING: "string",
  BOOLEAN: "boolean",
  DATE: "date",
  STATE: "state",
  MANY2ONE: "many2one", // 关联字段类型
  FLOAT: "float", // 浮点数类型
  MONETARY: "monetary", // 货币类型
};

// 操作符配置（全部可用的操作符）
export const availableOperators = [
  { value: "=", label: "=" },
  { value: "!=", label: "!=" },
  { value: "in", label: "in" },
  { value: "not in", label: "not in" },
  { value: "ilike", label: "ilike" },
  { value: ">", label: ">" },
  { value: ">=", label: ">=" },
  { value: "<", label: "<" },
  { value: "<=", label: "<=" },
];

// 为每种字段类型定义可用的操作符
export const operatorsByFieldType = {
  [fieldTypes.ID]: ["=", "in"],
  [fieldTypes.STRING]: ["=", "ilike", "in"],
  [fieldTypes.BOOLEAN]: ["="],
  [fieldTypes.DATE]: ["=", ">", ">=", "<", "<="],
  [fieldTypes.STATE]: ["=", "in"],
  [fieldTypes.MANY2ONE]: ["=", "in"],
  [fieldTypes.FLOAT]: ["=", ">", ">=", "<", "<="],
  [fieldTypes.MONETARY]: ["=", ">", ">=", "<", "<="],
};

// 状态选项（特定于采购订单的状态）
export const stateOptions = [
  { value: "draft", label: "RFQ (draft)" },
  { value: "sent", label: "RFQ已发送 (sent)" },
  { value: "purchase", label: "PO (purchase)" },
  { value: "done", label: "已完成 (done)" },
  { value: "cancel", label: "已取消 (cancel)" },
];

// 以字段为中心的模型配置
export const modelConfigs = {
  // 采购订单配置
  "purchase.order": {
    defaultTimeFilterField: "date_approve",
    // 字段配置，每个字段的所有属性都在这里定义一次
    fields: {
      id: {
        type: fieldTypes.ID,
        label: "PO ID",
        description: "PO Odoo ID",
        defaultSelected: true,
        sortIndex: 1,
      },
      name: {
        type: fieldTypes.STRING,
        label: "采购订单号",
        description: "采购订单号",
        defaultSelected: true,
        sortIndex: 2,
      },
      partner_id: {
        type: fieldTypes.MANY2ONE,
        label: "供应商/厂商",
        description: "供应商/厂商信息",
        defaultSelected: true,
        sortIndex: 3,
      },
      company_id: {
        type: fieldTypes.MANY2ONE,
        label: "公司系统",
        description: "公司系统",
        defaultSelected: true,
        sortIndex: 4,
      },
      state: {
        type: fieldTypes.STATE,
        label: "订单状态",
        description: "订单状态，如draft(RFQ), purchase(PO), done(已完成)等",
        defaultSelected: true,
        sortIndex: 5,
      },
      write_date: {
        type: fieldTypes.DATE,
        label: "最后修改日期",
        description: "最后修改日期",
        defaultSelected: true,
        sortIndex: 6,
      },
      x_studio_field_FWPP4: {
        type: fieldTypes.STRING,
        label: "Sale Order",
        description: "自定义 - Sale Order",
        defaultSelected: true,
        sortIndex: 7,
      },
      x_distributionmark: {
        type: fieldTypes.STRING,
        label: "分销标记",
        description: "自定义 - 分销标记",
        defaultSelected: true,
        sortIndex: 8,
      },
      x_studio_vendor_notified: {
        type: fieldTypes.BOOLEAN,
        label: "是否已向工厂发出PO邮件",
        description: "自定义 - 是否已向工厂发出PO邮件",
        defaultSelected: true,
        sortIndex: 9,
      },
      x_studio_actual_factory: {
        type: fieldTypes.MANY2ONE,
        label: "实际生产工厂",
        description: "自定义 - 实际生产工厂",
        defaultSelected: true,
        sortIndex: 10,
      },
      date_approve: {
        type: fieldTypes.DATE,
        label: "PO确认日期",
        description: "PO确认日期",
        defaultSelected: false,
        sortIndex: 51,
      },
      date_order: {
        type: fieldTypes.DATE,
        label: "RFQ创建日期",
        description: "RFQ创建日期",
        defaultSelected: false,
        sortIndex: 52,
      },
      date_planned: {
        type: fieldTypes.DATE,
        label: "计划到货日期",
        description: "计划到货日期",
        defaultSelected: false,
        sortIndex: 53,
      },
      create_date: {
        type: fieldTypes.DATE,
        label: "创建日期",
        description: "创建日期",
        defaultSelected: false,
        sortIndex: 54,
      },
      user_id: {
        type: fieldTypes.MANY2ONE,
        label: "负责人",
        description: "负责人信息",
        defaultSelected: false,
        sortIndex: 55,
      },
      order_line: {
        type: fieldTypes.STRING,
        label: "订单行项目",
        description: "订单行项目ID列表",
        defaultSelected: false,
        sortIndex: 56,
      },
      picking_ids: {
        type: fieldTypes.STRING,
        label: "相关的拦货单/入库单",
        description: "相关的拦货单/入库单ID列表",
        defaultSelected: false,
        sortIndex: 57,
      },
      notes: {
        type: fieldTypes.STRING,
        label: "备注",
        description: "备注",
        defaultSelected: false,
        sortIndex: 58,
      },
      receipt_status: {
        type: fieldTypes.STRING,
        label: "收货状态",
        description: "收货状态",
        defaultSelected: false,
        sortIndex: 59,
      },
      origin: {
        type: fieldTypes.STRING,
        label: "来源单据",
        description: "来源单据",
        defaultSelected: false,
        sortIndex: 60,
      },
    },
  },

  "purchase.order.line": {
    defaultTimeFilterField: "date_approve",
    fields: {
      id: {
        type: fieldTypes.ID,
        label: "ID",
        description: "订单行ID",
        defaultSelected: true,
        sortIndex: 1,
      },
      order_id: {
        type: fieldTypes.MANY2ONE,
        label: "订单引用",
        description: "关联的采购订单",
        defaultSelected: true,
        sortIndex: 2,
      },
      product_id: {
        type: fieldTypes.MANY2ONE,
        label: "产品",
        description: "订单行产品",
        defaultSelected: true,
        sortIndex: 3,
      },
      product_qty: {
        type: fieldTypes.FLOAT,
        label: "数量",
        description: "产品数量",
        defaultSelected: true,
        sortIndex: 4,
      },
      price_unit: {
        type: fieldTypes.FLOAT,
        label: "单价",
        description: "产品单价",
        defaultSelected: true,
        sortIndex: 5,
      },
      price_subtotal: {
        type: fieldTypes.MONETARY,
        label: "小计",
        description: "订单行小计金额",
        defaultSelected: true,
        sortIndex: 6,
      },
      name: {
        type: fieldTypes.STRING,
        label: "描述",
        description: "产品描述",
        defaultSelected: false,
        sortIndex: 7,
      },
    },
  },

  "product.product": {
    defaultTimeFilterField: "write_date",
    fields: {
      id: {
        type: fieldTypes.ID,
        label: "产品ID",
        description: "产品的唯一标识符",
        defaultSelected: true,
        sortIndex: 1,
      },
      name: {
        type: fieldTypes.STRING,
        label: "产品名称",
        description: "产品名称（依赖 product_tmpl_id.name）",
        defaultSelected: true,
        sortIndex: 2,
      },
      default_code: {
        type: fieldTypes.STRING,
        label: "产品型号",
        description: "产品型号",
        defaultSelected: true,
        sortIndex: 3,
      },
      product_tmpl_id: {
        type: fieldTypes.MANY2ONE,
        label: "产品模板",
        description: "关联的产品模板",
        defaultSelected: true,
        sortIndex: 4,
      },
      write_date: {
        type: fieldTypes.DATE,
        label: "更新日期",
        description: "产品更新日期",
        defaultSelected: true,
        sortIndex: 5,
      },
      company_id: {
        type: fieldTypes.MANY2ONE,
        label: "公司ID",
        description: "关联的公司",
        defaultSelected: true,
        sortIndex: 6,
      },
    },
  },

  "product.supplierinfo": {
    defaultTimeFilterField: "write_date",
    fields: {
      id: {
        type: fieldTypes.ID,
        label: "供应商信息ID",
        description: "供应商信息的唯一标识符",
        defaultSelected: true,
        sortIndex: 1,
      },
      product_id: {
        type: fieldTypes.MANY2ONE,
        label: "产品ID",
        description: "关联的产品",
        defaultSelected: true,
        sortIndex: 2,
      },
      partner_id: {
        type: fieldTypes.MANY2ONE,
        label: "供应商ID",
        description: "关联的供应商",
        defaultSelected: true,
        sortIndex: 3,
      },
      product_tmpl_id: {
        type: fieldTypes.MANY2ONE,
        label: "产品模板ID",
        description: "关联的产品模板",
        defaultSelected: true,
        sortIndex: 4,
      },
      write_date: {
        type: fieldTypes.DATE,
        label: "更新日期",
        description: "供应商信息更新日期",
        defaultSelected: true,
        sortIndex: 5,
      },
      company_id: {
        type: fieldTypes.MANY2ONE,
        label: "公司ID",
        description: "关联的公司",
        defaultSelected: true,
        sortIndex: 6,
      },
    },
  },

  "res.partner": {
    defaultTimeFilterField: "create_date",
    fields: {
      id: {
        type: fieldTypes.ID,
        label: "ID",
        description: "合作伙伴的唯一标识符",
        defaultSelected: true,
        sortIndex: 1,
      },
      company_id: {
        type: fieldTypes.MANY2ONE,
        label: "公司",
        description: "合作伙伴所属的公司",
        defaultSelected: true,
        sortIndex: 2,
      },
      name: {
        type: fieldTypes.STRING,
        label: "名称",
        description: "合作伙伴名称",
        defaultSelected: true,
        sortIndex: 3,
      },
      display_name: {
        type: fieldTypes.STRING,
        label: "显示名称",
        description: "合作伙伴的显示名称",
        defaultSelected: true,
        sortIndex: 4,
      },
      email: {
        type: fieldTypes.STRING,
        label: "电子邮件",
        description: "合作伙伴的电子邮件地址",
        defaultSelected: true,
        sortIndex: 5,
      },
      ref: {
        type: fieldTypes.STRING,
        label: "参考",
        description: "合作伙伴的参考编号",
        defaultSelected: true,
        sortIndex: 6,
      },
      street: {
        type: fieldTypes.STRING,
        label: "街道",
        description: "合作伙伴的街道地址",
        defaultSelected: true,
        sortIndex: 7,
      },
      street2: {
        type: fieldTypes.STRING,
        label: "街道2",
        description: "合作伙伴的第二街道地址",
        defaultSelected: false,
        sortIndex: 8,
      },
      vat: {
        type: fieldTypes.STRING,
        label: "增值税号",
        description: "合作伙伴的增值税号",
        defaultSelected: true,
        sortIndex: 9,
      },
      create_date: {
        type: fieldTypes.DATE,
        label: "创建日期",
        description: "合作伙伴创建日期",
        defaultSelected: true,
        sortIndex: 10,
      },
      city: {
        type: fieldTypes.STRING,
        label: "城市",
        description: "合作伙伴所在城市",
        defaultSelected: false,
        sortIndex: 11,
      },
      zip: {
        type: fieldTypes.STRING,
        label: "邮政编码",
        description: "合作伙伴的邮政编码",
        defaultSelected: false,
        sortIndex: 12,
      },
      country_id: {
        type: fieldTypes.MANY2ONE,
        label: "国家",
        description: "合作伙伴所在国家",
        defaultSelected: false,
        sortIndex: 13,
      },
    },
  },

  "sale.order": {
    defaultTimeFilterField: "date_order",
    fields: {
      id: {
        type: fieldTypes.ID,
        label: "SO ID",
        description: "销售订单 Odoo ID",
        defaultSelected: true,
        sortIndex: 1,
      },
      name: {
        type: fieldTypes.STRING,
        label: "销售订单号",
        description: "销售订单号",
        defaultSelected: true,
        sortIndex: 2,
      },
      order_line: {
        type: fieldTypes.STRING,
        label: "订单行项目",
        description: "订单行项目ID列表",
        defaultSelected: false,
        sortIndex: 3,
      },
      partner_id: {
        type: fieldTypes.MANY2ONE,
        label: "客户",
        description: "客户信息",
        defaultSelected: false,
        sortIndex: 4,
      },
      partner_shipping_id: {
        type: fieldTypes.MANY2ONE,
        label: "收货客户",
        description: "收货客户信息",
        defaultSelected: false,
        sortIndex: 5,
      },
      incoterm: {
        type: fieldTypes.STRING,
        label: "贸易术语",
        description: "贸易术语（Incoterm）",
        defaultSelected: true,
        sortIndex: 6,
      },
      client_order_ref: {
        type: fieldTypes.STRING,
        label: "客户订单号",
        description: "客户订单号",
        defaultSelected: false,
        sortIndex: 7,
      },
      date_order: {
        type: fieldTypes.DATE,
        label: "订单日期",
        description: "销售订单创建日期",
        defaultSelected: false,
        sortIndex: 8,
      },
      amount_untaxed: {
        type: fieldTypes.MONETARY,
        label: "未税金额",
        description: "未税金额",
        defaultSelected: false,
        sortIndex: 9,
      },
      amount_tax: {
        type: fieldTypes.MONETARY,
        label: "税额",
        description: "税额",
        defaultSelected: false,
        sortIndex: 10,
      },
      amount_total: {
        type: fieldTypes.MONETARY,
        label: "总金额",
        description: "总金额",
        defaultSelected: false,
        sortIndex: 11,
      },
      currency_id: {
        type: fieldTypes.MANY2ONE,
        label: "币种",
        description: "币种信息",
        defaultSelected: false,
        sortIndex: 12,
      },
      x_do_min_date: {
        type: fieldTypes.DATE,
        label: "最早发货日期",
        description: "自定义 - 最早发货日期",
        defaultSelected: true,
        sortIndex: 13,
      },
    },

    "account.incoterms": {
      defaultTimeFilterField: "write_date",
      fields: {
        id: {
          type: fieldTypes.ID,
          label: "ID",
          description: "贸易术语的唯一标识符",
          defaultSelected: true,
          sortIndex: 1,
        },
        name: {
          type: fieldTypes.STRING,
          label: "名称",
          description: "贸易术语名称",
          defaultSelected: true,
          sortIndex: 2,
        },
        code: {
          type: fieldTypes.STRING,
          label: "代码",
          description: "贸易术语代码",
          defaultSelected: true,
          sortIndex: 3,
        },
      },
    },

    "stock.picking": {
      defaultTimeFilterField: "date",
      fields: {
        id: {
          type: fieldTypes.ID,
          label: "送货单ID",
          description: "送货单的唯一标识符",
          defaultSelected: true,
          sortIndex: 1,
        },
        scheduled_date: {
          type: fieldTypes.DATE,
          label: "计划日期",
          description: "计划的日期",
          defaultSelected: true,
          sortIndex: 2,
        },
      },
    },
  },
};

// 辅助函数：获取字段描述
const getFieldDescriptions = (modelFields) => {
  const descriptions = {};
  Object.entries(modelFields).forEach(([fieldName, fieldConfig]) => {
    descriptions[fieldName] = fieldConfig.description;
  });
  return descriptions;
};

// 辅助函数：获取可用字段列表（用于UI展示）
const getAvailableFields = (modelFields) => {
  return Object.entries(modelFields)
    .map(([fieldName, fieldConfig]) => ({
      value: fieldName,
      label: fieldConfig.label,
    }))
    .sort((a, b) => {
      const orderA = modelFields[a.value].sortIndex || 999;
      const orderB = modelFields[b.value].sortIndex || 999;
      return orderA - orderB;
    });
};

// 辅助函数：获取默认选中的字段
const getDefaultSelectedFields = (modelFields) => {
  const defaultSelected = {};
  Object.entries(modelFields).forEach(([fieldName, fieldConfig]) => {
    defaultSelected[fieldName] = fieldConfig.defaultSelected || false;
  });
  return defaultSelected;
};

// 辅助函数：获取字段类型映射
const getFieldTypesMapping = (modelFields) => {
  const fieldTypesMap = {};
  Object.entries(modelFields).forEach(([fieldName, fieldConfig]) => {
    fieldTypesMap[fieldName] = fieldConfig.type;
  });
  return fieldTypesMap;
};

// 获取模型配置的主函数
export const getModelConfig = (modelName) => {
  const modelConfig = modelConfigs[modelName];

  if (!modelConfig) {
    return {
      fieldDescriptions: {},
      availableFields: [],
      defaultSelectedFields: {},
      fieldTypes: {},
      defaultTimeFilterField: undefined,
    };
  }

  const fields = modelConfig.fields;

  return {
    fieldDescriptions: getFieldDescriptions(fields),
    availableFields: getAvailableFields(fields),
    defaultSelectedFields: getDefaultSelectedFields(fields),
    fieldTypes: getFieldTypesMapping(fields),
    defaultTimeFilterField: modelConfig.defaultTimeFilterField,
  };
};
